var React = require('react');

function ArrowRightIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M12.11,21.47c0.3,0.34,0.7,0.53,1.12,0.53c0.42,0,0.82-0.19,1.12-0.53l7.18-8.19c0.15-0.17,0.27-0.37,0.34-0.59\n                C21.96,12.47,22,12.24,22,12c0-0.24-0.04-0.47-0.12-0.69c-0.08-0.22-0.2-0.42-0.35-0.59l-7.18-8.19c-0.62-0.7-1.62-0.7-2.24,0\n                c-0.62,0.71-0.62,1.85,0,2.56l4.48,5.11H3.43C2.55,10.19,2,11,2,12s0.55,1.81,1.43,1.81h13.16l-4.48,5.11\n                C11.49,19.62,11.5,20.77,12.11,21.47z"}));
}

ArrowRightIcon.defaultProps = {"data-dmid":"dm-arrow-right","viewBox":"0 0 24 24","width":"24","height":"24","role":"img","pointerEvents":"none","color":"color2"};

module.exports = ArrowRightIcon;

ArrowRightIcon.default = ArrowRightIcon;
